import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import ExpandableContent from '../../components/global/ExpandableContent/ExpandableContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import tracking from 'dibs-tracking';
import classNames from 'classnames';

function trackToggle(isExpanded) {
    return () => {
        return tracking.trackEvent({
            label: isExpanded ? 'expand' : 'collapse',
            category: 'product',
            action: 'pdp description interaction',
        });
    };
}

function PdpSharedDescriptionAbout(props) {
    const { headerClass, contentClass, item } = props;
    if (!item || !item.description) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description" className={styles.wrapper}>
            <h2
                className={classNames(styles.header, headerClass)}
                data-tn="pdp-item-description-title"
            >
                <FormattedMessage
                    id="PdpSharedDescriptionAbout.aboutHeader"
                    defaultMessage="About"
                />
            </h2>
            <ExpandableContent
                className={classNames(styles.content, contentClass)}
                buttonClassName={styles.button}
                onToggleReadMore={trackToggle}
                collapseHeight={144}
                dataTn="pdp-item-description-content"
            >
                <span dangerouslySetInnerHTML={{ __html: item.description }} />
            </ExpandableContent>
        </div>
    );
}

PdpSharedDescriptionAbout.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDescriptionAbout, {
    item: graphql`
        fragment PdpSharedDescriptionAbout_item on Item {
            description
        }
    `,
});
